// 생기부 "자료함에서 고르기" (Phase 4b/4c) — 순수 헬퍼.
// 자료함 항목을 업로드 파일과 같은 자리(fileUpload.files / referenceFiles)에 넣기 위한 변환.
// (첨부 버튼 메뉴 UI 는 components/saenggibu/SaenggibuAttachMenu.)

export const LIBRARY_SOURCE = 'library';

// 칩·메타에 보이는 이름: 파일 자료는 원본 파일명, 텍스트 자료는 제목 (서버 material_display_name 과 동일 규칙)
export const libraryMaterialDisplayName = (material = {}) => (
  String(material.source_filename || material.title || '자료함 자료').trim()
);

/**
 * 업로드 File 대신 fileUpload.files 에 들어가는 가짜 파일 객체.
 * name/size/type 만 읽는 기존 UI(칩·용량 표시)가 그대로 동작하고, isLibraryMaterial 로 구분한다.
 */
export const createLibraryPseudoFile = (material = {}) => ({
  name: libraryMaterialDisplayName(material),
  size: Number(material.char_count) || 0,
  type: `library/${String(material.file_type || 'text').toLowerCase()}`,
  isLibraryMaterial: true,
  materialId: String(material.id || ''),
  planLike: Boolean(material.plan_like),
});

export const isLibraryPseudoFile = (file) => Boolean(file && file.isLibraryMaterial && file.materialId);

/**
 * 기록 저장 요청(uploaded_files[] / referenceFiles[])에 넣는 descriptor.
 * 서버 build_attachment_meta 가 source=library 를 보고 재사용 제안 대상에서 뺀다. 본문은 싣지 않는다.
 */
export const buildLibraryAttachmentDescriptor = (material = {}) => ({
  name: libraryMaterialDisplayName(material),
  size: Number(material.char_count) || 0,
  source: LIBRARY_SOURCE,
  material_id: String(material.id || ''),
});
